module.exports = __webpack_public_path__ + "img/areaRedBusiness.23fce2a9.png";